import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type {
    Plan,
    PremiumPricingPanelState,
    YotpoReviewsMeta
} from "@Panels/premium-pricing-panel/premium-pricing-panel.types";
import {PlanCycle} from "@Panels/premium-pricing-panel/premium-pricing-panel.types";
import {getPlansForPricingDialog} from "@Panels/premium-pricing-panel/premium-pricing-panel-thunk";
import {mapSubscriptionPlanToPlan} from "@Panels/premium-pricing-panel/premium-pricing-library";
import type {SubscriptionPlan} from "@Panels/change-plan-modal/change-plan-modal.types";

const initialState: PremiumPricingPanelState = {
    plans: [],
    isWaitingForAJAXResponse: false,
    selectedCycle: PlanCycle.MONTHLY,
    yotpoData: undefined
};

export const premiumPricingPanelSlice = createSlice({
    name: 'premiumPricingPanel',
    initialState,
    reducers: {
        updateSelectedCycle: (state, {payload}: PayloadAction<PlanCycle>) => {
            state.selectedCycle = payload;
        },
        setIsWaitingForAJAXResponse: (state, {payload}: PayloadAction<boolean>) => {
            state.isWaitingForAJAXResponse = payload;
        },
        updatePlans: (state, {payload}: PayloadAction<Plan[]>) => {
            state.plans = payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPlansForPricingDialog.pending, (state) => {
            state.isWaitingForAJAXResponse = true;
        });
        builder.addCase(getPlansForPricingDialog.fulfilled, (state, {payload}: PayloadAction<{
            plans: SubscriptionPlan[],
            yotpoData: YotpoReviewsMeta
        }>) => {
            state.plans = Object.values(payload.plans).map((plan: SubscriptionPlan) => {
                return mapSubscriptionPlanToPlan(plan);
            });
            if (payload.yotpoData !== null) {
                state.yotpoData = payload.yotpoData;
            }
            state.isWaitingForAJAXResponse = false;
        });
        builder.addCase(getPlansForPricingDialog.rejected, (state) => {
            state.isWaitingForAJAXResponse = false;
        });
    }
});

export const {updateSelectedCycle, setIsWaitingForAJAXResponse, updatePlans} = premiumPricingPanelSlice.actions;
export const premiumPricingPanelReducer = premiumPricingPanelSlice.reducer;